import { lazy, memo } from 'react'

import { useAppStoreSelector } from '../hooks/useAppStoreSelector'
import {
  selectAppStatus,
  selectIsRootLauncherJourney
} from '../store/selectors/config'
import { APP_STATUS } from '../store/types/enums'

import { SpinnerPage } from './SpinnerPage'

const JourneyApp = lazy(() => import('./JourneyApp'))
const LauncherApp = lazy(() => import('./LauncherApp'))

export const AppComponent = memo(() => {
  const appStatus = useAppStoreSelector(selectAppStatus)
  const isLauncher = useAppStoreSelector(selectIsRootLauncherJourney)

  if (appStatus !== APP_STATUS.READY) {
    return <SpinnerPage />
  }

  const Component = isLauncher ? LauncherApp : JourneyApp

  return <Component />
})

AppComponent.displayName = 'AppComponent'
